export const MAX_NAME_LENGTH = 30;
export const MAX_VALUE_LENGTH = 30;
